module.exports = __webpack_public_path__ + "img/ambulance.5e2b75a9.svg";